// @flow
import React from 'react';
import { Link } from 'react-router';

import S from './style.css';

const Home = (): React$Element<{}> => (
  <div>
    <div className={`pv2 pv4-ns ph0 ${S.headline}`}>
      <div className="inner">
        <h1 className={`${S.tagline} fw3 mv0 lh-title`}>
          Introducing Lux.<br />
          Build scalable, Node.js-powered<br />
          REST APIs with almost no code.
        </h1>
        <div className={`${S.status} mt3 pt3 lh-copy`}>
          <a
            href="https://circleci.com/gh/postlight/lux/tree/master"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              alt="CircleCI Build"
              className="mr2 mb2"
              src="https://img.shields.io/circleci/project/github/postlight/lux/master.svg?style=flat-square"
            />
          </a>
          <a
            href="https://ci.appveyor.com/project/zacharygolba/lux/branch/master"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              alt="AppVeyor Build"
              className="mr2 mb2"
              src="https://img.shields.io/appveyor/ci/zacharygolba/lux/master.svg?style=flat-square"
            />
          </a>
          <a
            href="https://codecov.io/gh/postlight/lux"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              alt="Code Coverage"
              className="mr2 mb2"
              src="https://img.shields.io/codecov/c/github/postlight/lux/master.svg?style=flat-square"
            />
          </a>
          <a
            href="https://david-dm.org/postlight/lux"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              alt="Dependency Status"
              className="mr2 mb2"
              src="https://img.shields.io/david/postlight/lux.svg?style=flat-square"
            />
          </a>
          <a
            href="https://badge.fury.io/js/lux-framework"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              alt="NPM Package"
              className="mr2 mb2"
              src="https://img.shields.io/npm/v/lux-framework.svg?style=flat-square"
            />
          </a>
          <a
            href="https://gitter.im/postlight/lux?utm_source=badge&amp;utm_medium=badge&amp;utm_campaign=pr-badge&amp;utm_content=badge"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              alt="Join the chat at https://gitter.im/postlight/lux"
              className="mr2 mb2"
              src="https://img.shields.io/gitter/room/postlight/lux.svg?style=flat-square"
            />
          </a>
        </div>
      </div>
    </div>
    <div className={`pt3 pt4-ns bg-light ${S.features}`}>
      <div className="inner">
        <ul className="list pa0 ma0">
          <li className={`v-base mb4 mb0-ns ${S.api}`}>
            <h3 className="mt0 mb2">
              Build APIs with ease
            </h3>
            <p className="ma0">
              Lux uses JavaScript&apos;s standard library rather than
              creating a ton of functions you&apos;ll have to learn and
              remember. Once you learn it, you can put the docs aside.
            </p>
          </li>
          <li className={`v-base mb4 mb0-ns ${S.modernjs}`}>
            <h3 className="mt0 mb2">
              Created with modern JavaScript
            </h3>
            <p className="ma0">
              Lux embraces ES2015 and beyond, including support for classes,
              modules, promises, async/await, and arrow functions.
            </p>
          </li>
          <li className={`v-base mb4 mb0-ns ${S.support}`}>
            <h3 className="mt0 mb2">
              Robust community support
            </h3>
            <p className="ma0">
              Lux framework&apos;s enthusiastic community of contributors
              offers a built-in support structure for troubleshooting.
              Submitted issues are addressed quickly and respectfully.
            </p>
          </li>
          <li className={`v-base mb4 mb0-ns ${S.easystart}`}>
            <h3 className="mt0 mb2">
              Easy startup
            </h3>
            <p className="ma0">
              Setup is as easy as installing the Lux framework, creating a
              new project and running the application. That&apos;s it.
            </p>
          </li>
        </ul>
        <div className={`${S.footer} pv4 mt2 df`}>
          <div className={S.copy}>
            <h2 className="fw3 mt0 mb2 nowrap">
              Download Lux, and get up and<br />
              running in minutes.
            </h2>
          </div>
          <Link className="ph4 pv3 br1" to="/docs/latest">
            Get Started
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.jsx